import { PrimaryLanguageEnum } from 'domains/client';
import { DirectSignupFiltersFormType } from 'domains/signupDirect/schemas/filtersSchema';
import {
  AdultConcernOption,
  PediatricConcernOption,
  SIGNUP_CONCERNS_ADULT_COMBINATION_EXCEPTIONS,
} from 'domains/signupDirect/misc/communicationConcerns';
import { TherapyTargetValue } from 'domains/signupDirect/misc/constants';

/**
 * Single source of truth for determining if a lead can go to evaluation
 */

export const filtersAllowForEvaluation = ({
  paymentMethod,
  target,
  clinicalConcerns,
  language,
  isResumedLead,
}: {
  target?: TherapyTargetValue;
  paymentMethod?: DirectSignupFiltersFormType['paymentMethod'];
  clinicalConcerns?: PediatricConcernOption[] | AdultConcernOption[];
  language?: PrimaryLanguageEnum;
  isResumedLead?: boolean;
}) => {
  if (!target || !clinicalConcerns?.length || !paymentMethod) {
    return { allowed: false, reason: 'Incomplete form' };
  }

  if (paymentMethod.type === 'otherInsurance') {
    return { allowed: false, reason: `Picked can't find my insurance` };
  }
  if (isResumedLead) {
    return { allowed: true, reason: 'Resumed lead ID is allowed' }; // Resumed leads bypass the rules below
  }

  if (language !== PrimaryLanguageEnum.English) {
    return { allowed: false, reason: 'Non-English language selected' };
  }
  if (clinicalConcerns.some(c => c.allowEval === false)) {
    return { allowed: false, reason: 'One or more clinical concerns disallow evaluation' };
  }
  if (paymentMethod.type === 'insurance') {
    if (clinicalConcerns.every(concern => SIGNUP_CONCERNS_ADULT_COMBINATION_EXCEPTIONS.includes(concern.key))) {
      return { allowed: false, reason: 'Selected clinical concerns disallow evaluation for insurance' };
    }
  }

  if (paymentMethod.type === 'privatePay') {
    return { allowed: true, reason: 'Private pay is allowed' };
  }
  const { insuranceData: insurance } = paymentMethod;
  if (insurance && insurance.allowSelfSignUp) {
    return { allowed: true, reason: 'Insurance allows self sign-up' };
  }
  return { allowed: false, reason: 'Default exclusion reason' };
};
